<footer class="main-footer">
    <div class="float-right d-none d-sm-block">
      <b>Desarrollado por: </b> Yavé
    </div>
    <strong>Copyright &copy; 2024.</strong> Todos los derechos reservados.
  </footer>